import { api } from '@/api/ApiGateway.js'

class OrganizationGroupsApi
{
	create(orgGroupData, onSuccess, onError)
	{
		api.post('organization-groups', orgGroupData).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error creating organization group.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	update(orgGroupData, onSuccess, onError)
	{
		api.patch('organization-groups', orgGroupData).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error updating organization group.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	delete(orgGroupId, onSuccess, onError)
	{
		api.delete(`organization-groups/${orgGroupId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			try
			{
				onSuccess(response.body()?.success)
			}
			catch (e)
			{
				response.overrideError({ detail: 'Error deleting organization group.' })
				onError(response)
			}
		})
	}
}

export const organizationGroupsApi = new OrganizationGroupsApi()